import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography, Stack, Button, Badge, Alert } from '@mui/material';
import useFetch from '../../hooks/useFetch';
import { Sheet } from '../../components';
import InvoiceFlow from './InvoiceFlow';

export default function ToConfirm({ setAuth, onSaved, accounts, refreshKey }) {
  const { t } = useTranslation();
  const { fetchResource } = useFetch({ setAuth });
  const [readings, setReadings] = useState([]);
  const [open, setOpen] = useState(null);
  const [error, setError] = useState('');
  const load = () => fetchResource({ method: 'GET', resource: 'calendar/photos' }).then(r => setReadings((r.readings || []).filter(x => x.kind === 'invoice')));

  useEffect(() => { load(); }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!readings.some(r => r.status === 'queued' || r.status === 'reading')) return;
    const timer = setTimeout(load, 5000);
    return () => clearTimeout(timer);
  }, [readings]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!readings.length) return null;
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        {error && <Alert severity='error'>{error}</Alert>}
        <Badge badgeContent={readings.length} color='primary'><Typography variant='subtitle1'>{t('calendar.toConfirm')}</Typography></Badge>
        {readings.map(r => (
          <Stack key={r.id} direction='row' spacing={1} alignItems='center' sx={{ mt: 1 }}>
            <Typography sx={{ flex: 1 }}>{r.result?.vendor_name || (r.status === 'failed' ? t('calendar.invoice.readFailed') : t('calendar.invoice.reading'))}</Typography>
            <Button size='small' disabled={r.status !== 'done' && r.status !== 'failed'} onClick={() => setOpen(r)}>{t('common.confirm')}</Button>
            <Button size='small' onClick={async () => {
              const res = await fetchResource({ resource: `calendar/photos/${r.id}/dismiss` });
              if (res.error) return setError(res.error);
              setError('');
              load();
            }}>{t('calendar.dismiss')}</Button>
          </Stack>
        ))}
      </CardContent>
      {open && (
        <Sheet open onClose={() => setOpen(null)} title={t('calendar.addInvoice')} size='sm'>
          <InvoiceFlow date={open.created_at?.slice(0, 10)} accounts={accounts} setAuth={setAuth} resume={{ readingIds: [open.id], reading: open }}
            onCancel={() => setOpen(null)} onSaved={() => { setOpen(null); load(); onSaved(); }} />
        </Sheet>
      )}
    </Card>
  );
}
